/**
 * Simple MFA validation utilities
 */

export const MFA_CODE_LENGTH = 6;
export const BACKUP_CODE_LENGTH = 8;

type MFAValidationErrorKey = 'required' | 'invalid';

export const validateMFACodeFormat = (
  code: string
): { isValid: boolean; errorKey?: MFAValidationErrorKey } => {
  if (!code) {
    return { isValid: false, errorKey: 'required' };
  }

  const cleaned = code.replace(/[\s-]/g, '');

  // 6-digit TOTP code
  if (/^\d{6}$/.test(cleaned)) {
    return { isValid: true };
  }

  // 8-character backup code
  if (/^[a-zA-Z0-9]{8}$/.test(cleaned)) {
    return { isValid: true };
  }

  return { isValid: false, errorKey: 'invalid' };
};

export const sanitizeMFAInput = (
  value: string,
  isBackupCode: boolean = false
): string => {
  if (isBackupCode) {
    // For backup codes, allow alphanumeric characters, spaces, and dashes
    return value.replace(/[^a-zA-Z0-9\s-]/g, '');
  }
  // For TOTP codes, only allow digits
  return value.replace(/[^0-9]/g, '');
};

export const formatSecretForDisplay = (secret: string): string =>
  secret.replace(/(.{4})/g, '$1 ').trim();
